export default class Contact {

    constructor() {
        if (document.querySelector('#contact') !== null) {
            this.initMap();
        }
    }

    initMap() {
        let bounds = new google.maps.LatLngBounds();
        const maps = document.getElementById("maps");

        const map = new google.maps.Map(maps, {
            zoom: 12,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: [
                {
                    "featureType": "administrative",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#444444"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "all",
                    "stylers": [
                        {
                            "color": "#f2f2f2"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "poi.business",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "all",
                    "stylers": [
                        {
                            "saturation": -100
                        },
                        {
                            "lightness": 45
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "all",
                    "stylers": [
                        {
                            "color": "#b4d4e1"
                        },
                        {
                            "visibility": "on"
                        }
                    ]
                }
            ]
        });

        const markers = [];

        const locations = [
            {
                latitude: 51.685440, // 's Hertogenbosch
                longitude: 5.293560
            },
            {
                latitude: 51.440620, // Eindhoven
                longitude: 5.474700
            }
        ]

        locations.forEach((location, i) => {
            const icon = {
                url: "/img/icon-map.png", // url
                scaledSize: new google.maps.Size(44, 44), // scaled size
                origin: new google.maps.Point(0, 0), // origin
                anchor: new google.maps.Point(22, 22) // anchor
            };

            const marker = new google.maps.Marker({
                position: new google.maps.LatLng(location.latitude, location.longitude),
                map: map,
                icon: icon
            });

            bounds.extend(marker.position);;

            markers.push(marker);
        });

        map.fitBounds(bounds);
    }

}
